import { ReorderOpType } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';

// 移动调整类型 - sdk对上层类型映射
export const MOVE_OPERATION_TYPE_MAP = new Map([
    [-1, ReorderOpType?.Backward],
    [1, ReorderOpType?.Forward],
    [0, ReorderOpType?.Back],
    [2, ReorderOpType?.Front],
]);
